<template>
  <div>
    <!-- <v-row class="remove-print">
      <v-col cols="12" md="12" sm="12">
        <v-text-field
          v-model="findForm.nomor_nota"
          :loading="loading.nomor_nota"
          :disabled="loading.nomor_nota"
          label="No Nota"
          outlined
          clearable
          dense
          small-chips
          hide-details
          autofocus
          @keydown.enter="fetchInvoice"
        ></v-text-field>
      </v-col>
    </v-row> -->

    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="p-1">
          <v-row>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="No Nota"
                dense
                small-chips
                hide-details
                disabled
                v-model="formData.nomor_nota"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                label="Kode Nota"
                dense
                hide-details
                :items="items.kode_nota"
                v-model="formData.kode_nota"
                @change="updateInvoice"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                label="Ditagih Kepada"
                dense
                hide-details
                :items="items.customers"
                :loading="loading.customers"
                :disabled="loading.customers"
                v-model="formData.ditagih_kepada"
                @change="updateInvoice"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="invoice-item">
            <v-col cols="12" md="2" lg="2" style="height: 250px">
              <v-text-field
                label="Kode TTB"
                outlined
                dense
                small-chips
                hide-details
                :loading="loading.invoiceDetil"
                v-model="invoiceDetilFormData.kodettb"
                @keydown.enter="addInvoiceDetil"
                ref="focusNoTTB"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="10"
              lg="10"
              class="overflow-auto"
              style="height: 250px"
            >
              <v-simple-table height="250px" fixed-header dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">KC / NoCont</th>
                      <th class="text-left">KS</th>
                      <th class="text-left">Kode TTB</th>
                      <th class="text-left">No TTB</th>
                      <th class="text-left">Kondisi Pengiriman</th>
                      <th class="text-left">Pengirim</th>
                      <th class="text-left">Penerima</th>
                      <th class="text-left">Jumlah</th>
                      <th class="text-left">Keterangan</th>
                      <th class="text-left">Kubikasi</th>
                      <th class="text-left">Tonase</th>
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoiceDetil" :key="item.id">
                      <td>{{ item.kc }} / {{ item.nomor_container }}</td>
                      <td>{{ item.ks }}</td>
                      <td>{{ item.ttb.kodettb }}</td>
                      <td>{{ item.ttb.nottb }}</td>
                      <td>{{ item.ttb.kondisi_detil.kondisi }}</td>
                      <td>{{ item.ttb.pengirim_detil.nama }}</td>
                      <td>{{ item.ttb.penerima_detil.nama }}</td>
                      <td>
                        {{
                          item.koli_in != null
                            ? item.koli_in
                            : item.ttb.total_koli
                        }}
                      </td>
                      <td>{{ item.ttb.ket }}</td>
                      <td>{{ getKubikasi(item.ttb.ttb_rinci) }}</td>
                      <td>{{ getTonase(item.ttb.ttb_rinci) }}</td>
                      <td>
                        <v-icon @click="deleteItem(item.ttb.kodettb)">
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" lg="3" style="height: 250px">
              <v-text-field
                label="Tanggal Lunas"
                outlined
                dense
                small-chips
                hide-details
                type="date"
                v-model="formData.tgl_lunas"
                @blur="updateInvoice"
                @keydown.enter="updateInvoice"
              ></v-text-field>

              <!-- <v-text-field
                label="KV"
                outlined
                dense
                small-chips
                hide-details
                type="number"
                class="mt-2"
                v-model="formData.kv"
                @blur="updateInvoice"
                @keydown.enter="updateInvoice"
              ></v-text-field> -->

              <!-- :disabled="!formData.tgl_lunas" -->
              <v-btn
                color="primary"
                elevation="2"
                class="w-100 mt-2"
                @click="printInvoice"
                :loading="state.loadingPrint"
                >Print Nota</v-btn
              >

              <h4 class="mt-3">
                No Pelunasan:
                <span v-if="formData.no_pelunasan">{{
                  formData.no_pelunasan
                }}</span>
              </h4>
              <h4 class="mt-1" v-if="vesselInfo">
                Nama Kapal: {{ vesselInfo.nama_kapal || "-" }}
              </h4>
              <h4 class="mt-1" v-if="vesselInfo">
                Voy: {{ vesselInfo.voy || "-" }}
              </h4>
              <h4 class="mt-1" v-if="formData.kv">KV: {{ formData.kv }}</h4>
            </v-col>

            <v-col cols="12" md="9" lg="9">
              <v-row>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Koli"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_koli"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Kubikasi"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_kubikasi"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Tonase"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_tonase"
                  ></v-text-field>
                </v-col>
              </v-row>

              <table>
                <tbody>
                  <tr>
                    <td>
                      <h3>I:</h3>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        dense
                        small-chips
                        hide-details
                        v-model="formData.i_jumlah"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-autocomplete
                        :items="items.units"
                        dense
                        hide-details
                        v-model="formData.i_satuan"
                        @change="updateInvoice"
                      ></v-autocomplete>
                    </td>
                    <td>x</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="i_harga"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        disabled
                        v-model="i_total"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h3>II:</h3>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        dense
                        small-chips
                        hide-details
                        v-model="formData.ii_jumlah"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-autocomplete
                        dense
                        hide-details
                        :items="items.units"
                        v-model="formData.ii_satuan"
                        @change="updateInvoice"
                      ></v-autocomplete>
                    </td>
                    <td>x</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="ii_harga"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        disabled
                        v-model="ii_total"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="formData.biaya_lain"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="biaya_lain_total"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td colspan="2" style="text-align: right"></td>
                    <td></td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        dense
                        small-chips
                        hide-details
                        type="text"
                        disabled
                        v-model="total_semua"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="5"
                      style="text-align: right; padding-right: 10px"
                    >
                      <v-checkbox
                        v-model="formData.use_ppn"
                        dense
                        hide-details
                        class="d-inline-block"
                        style="margin-top: -4px"
                        @change="onPpnChange"
                      >
                        <template v-slot:label>
                          <span style="margin-right: 10px">PPN</span>
                        </template>
                      </v-checkbox>
                      <v-text-field
                        v-if="formData.use_ppn"
                        type="number"
                        dense
                        small-chips
                        hide-details
                        suffix="%"
                        style="width: 80px; display: inline-block"
                        v-model="formData.ppn_percentage"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td v-if="formData.use_ppn">=</td>
                    <td v-if="!formData.use_ppn"></td>
                    <td>
                      <v-text-field
                        v-if="formData.use_ppn"
                        dense
                        small-chips
                        hide-details
                        type="text"
                        disabled
                        v-model="ppn_amount_display"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="5"
                      style="text-align: right; padding-right: 10px"
                    >
                      <v-checkbox
                        v-model="formData.use_pph"
                        dense
                        hide-details
                        class="d-inline-block"
                        style="margin-top: -4px"
                        @change="onPphChange"
                      >
                        <template v-slot:label>
                          <span style="margin-right: 10px">PPh</span>
                        </template>
                      </v-checkbox>
                      <v-text-field
                        v-if="formData.use_pph"
                        type="number"
                        dense
                        small-chips
                        hide-details
                        suffix="%"
                        style="width: 80px; display: inline-block"
                        v-model="formData.pph_percentage"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                    <td v-if="formData.use_pph">=</td>
                    <td v-if="!formData.use_pph"></td>
                    <td>
                      <v-text-field
                        v-if="formData.use_pph"
                        dense
                        small-chips
                        hide-details
                        type="text"
                        disabled
                        v-model="pph_amount_display"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr v-if="formData.use_ppn || formData.use_pph">
                    <td></td>
                    <td></td>
                    <td colspan="2" style="text-align: right"></td>
                    <td></td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        dense
                        small-chips
                        hide-details
                        type="text"
                        disabled
                        v-model="grand_total"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </table>

              <v-text-field
                label="Terbilang"
                outlined
                dense
                small-chips
                hide-details
                class="mt-2"
                disabled
                v-model="formData.terbilang"
              ></v-text-field>

              <v-text-field
                label="Keterangan Tagihan"
                outlined
                dense
                small-chips
                hide-details
                class="mt-2"
                v-model="formData.keterangan_barang"
                @blur="updateInvoice"
                @keydown.enter="updateInvoice"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.nomor_nota"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h3 class="report-title">NOTA PENAGIHAN BIAYA PENGIRIMAN BARANG</h3>
          <h4 class="text-center">{{ companyName }}</h4>
        </div>
        <div class="right ml-5">
          <table>
            <tr>
              <td>Nomor Nota</td>
              <td>:</td>
              <td class="border">{{ data.nomor_nota }}</td>
            </tr>
            <tr>
              <td>Kode Nota</td>
              <td>:</td>
              <td class="border-dotted">{{ data.kode_nota }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="mt-4">
        <div class="invoice-info">
          <h4 class="mb-0 font-italic">
            Ditagih Kepada: {{ data.customer.nama }}
          </h4>
          <h4 class="mb-0 font-italic" v-if="data.no_pelunasan">
            No Pelunasan: {{ data.no_pelunasan }}
          </h4>
          <h4 class="mb-0 font-italic">
            Nama Kapal: {{ data.vessel.nama_kapal }}
          </h4>
          <h4 class="mb-0 font-italic">Voy: {{ data.vessel.voy || "-" }}</h4>
          <h4 class="mb-0 font-italic">KV: {{ data.vessel.kv || "-" }}</h4>
          <h4 class="mb-0 font-italic" v-if="data.keterangan_barang">
            Keterangan Tagihan: {{ data.keterangan_barang }}
          </h4>
        </div>

        <div class="items mt-3">
          <p class="m-0">Keterangan Pengiriman:</p>

          <table width="100%">
            <thead>
              <th>Kode TTB</th>
              <th>No TTB</th>
              <th>Kondisi</th>
              <th>Dikirim Kepada</th>
              <th class="hide-on-print">Tonase</th>
              <th class="hide-on-print">Kubikasi</th>
              <th>Koli</th>
              <th>Packing</th>
            </thead>
            <tbody>
              <tr v-for="item in data.invoice_detil" :key="item.id">
                <td class="text-center">{{ item.kodettb }}</td>
                <td class="text-center">{{ item.nottb }}</td>
                <td class="text-center">
                  {{ item.ttb.kondisi_detil.kondisi | "-" }}
                </td>
                <td class="text-center">
                  {{ item.ttb.penerima_detil.nama | "-" }}
                </td>
                <td class="text-center hide-on-print">
                  {{ getTonase(item.ttb.ttb_rinci) }}
                </td>
                <td class="text-center hide-on-print">
                  {{ getKubikasi(item.ttb.ttb_rinci) }}
                </td>
                <td class="text-center">
                  {{
                    item.koli_in != null
                      ? item.koli_in
                      : getKoli(item.ttb.ttb_rinci)
                  }}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="price d-flex justify-center mt-5 mb-5">
            <table width="70%">
              <tbody>
                <tr>
                  <td>I:</td>
                  <td class="text-center">
                    {{ data.i_jumlah }} {{ data.i_satuan }}
                  </td>
                  <td>x</td>
                  <td class="text-center">
                    {{ formatCurrency(data.i_harga) }}
                  </td>
                  <td>=</td>
                  <td>{{ formatCurrency(data.i_total) }}</td>
                </tr>
                <tr>
                  <td>II:</td>
                  <td class="text-center">
                    {{ data.ii_jumlah }} {{ data.ii_satuan }}
                  </td>
                  <td>x</td>
                  <td class="text-center">
                    {{ formatCurrency(data.ii_harga) }}
                  </td>
                  <td>=</td>
                  <td>{{ formatCurrency(data.ii_total) }}</td>
                </tr>
                <tr>
                  <td colspan="4" class="text-center">{{ data.biaya_lain }}</td>
                  <td>=</td>
                  <td>{{ formatCurrency(data.biaya_lain_total) }}</td>
                </tr>
                <tr>
                  <td colspan="5"></td>
                  <td>
                    {{
                      formatCurrency(
                        Math.abs(data.i_total) +
                          Math.abs(data.ii_total) +
                          Math.abs(data.biaya_lain_total)
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="data.use_ppn">
                  <td colspan="4" class="text-center">
                    PPN ({{ data.ppn_percentage }}%)
                  </td>
                  <td>=</td>
                  <td>{{ formatCurrency(data.ppn_amount) }}</td>
                </tr>
                <tr v-if="data.use_pph">
                  <td colspan="4" class="text-center">
                    PPh ({{ data.pph_percentage }}%)
                  </td>
                  <td>=</td>
                  <td>{{ formatCurrency(data.pph_amount) }}</td>
                </tr>
                <tr v-if="data.use_ppn || data.use_pph">
                  <td colspan="5" class="text-right">
                    <strong>=</strong>
                  </td>
                  <td>
                    <strong>{{
                      formatCurrency(
                        Math.abs(data.i_total) +
                          Math.abs(data.ii_total) +
                          Math.abs(data.biaya_lain_total) +
                          (data.use_ppn ? data.ppn_amount : 0) -
                          (data.use_pph ? data.pph_amount : 0)
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">{{ data.terbilang }}</td>
                </tr>
                <tr>
                  <td colspan="4" class="pt-5"></td>
                  <td colspan="2" class="pt-5">Pontianak, {{ tgl_nota }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- Pop Up fetch invoice data -->
    <FindNomorNota :openModal="!haveNomorNota" @close-modal="setInvoiceData" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="formatForm"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  components: {
    FindNomorNota: () => import("@/components/Invoice/InvoiceModal.vue")
  },
  data() {
    return {
      haveNomorNota: false,
      state: {
        loading: false,
        no_data: true,
        loadingPrint: false,
        noData: true
      },
      loading: {
        nomor_nota: false,
        customers: false,
        invoiceDetil: false
      },
      findForm: {
        nomor_nota: "",
        nama_kapal: ""
      },
      items: {
        kode_nota: [
          {
            text: "P",
            value: "P"
          },
          {
            text: "L",
            value: "L"
          },
          {
            text: "ND",
            value: "ND"
          }
        ],
        customers: [],
        units: [
          {
            text: "M3",
            value: "M3"
          },
          {
            text: "Ton",
            value: "Ton"
          },
          {
            text: "Unit",
            value: "Unit"
          },
          {
            text: "Container",
            value: "Container"
          }
        ]
      },
      formData: {},
      invoiceDetil: [],
      invoiceDetilFormData: {
        kodettb: ""
      },
      data: {},
      vesselInfo: null,
      defaultPpnPercentage: 0,
      defaultPphPercentage: 0,
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    i_harga: {
      get() {
        return this.formatCurrency(this.formData.i_harga);
      },
      set(value) {
        return (this.formData.i_harga = this.convertToAngka(value));
      }
    },
    ii_harga: {
      get() {
        return this.formatCurrency(this.formData.ii_harga);
      },
      set(value) {
        return (this.formData.ii_harga = this.convertToAngka(value));
      }
    },
    i_total: {
      get() {
        return this.formatCurrency(
          this.formData.i_jumlah * this.formData.i_harga
        );
      },
      set(value) {
        return (this.formData.i_total = this.convertToAngka(value));
      }
    },
    ii_total: {
      get() {
        return this.formatCurrency(
          this.formData.ii_jumlah * this.formData.ii_harga
        );
      },
      set(value) {
        return (this.formData.ii_total = this.convertToAngka(value));
      }
    },
    biaya_lain_total: {
      get() {
        return this.formatCurrency(this.formData.biaya_lain_total);
      },
      set(value) {
        return (this.formData.biaya_lain_total = this.convertToAngka(value));
      }
    },
    total_semua() {
      return this.formatCurrency(
        this.convertToAngka(this.i_total) +
          this.convertToAngka(this.ii_total) +
          this.formData.biaya_lain_total
      );
    },
    grand_total() {
      const dpp = this.convertToAngka(this.total_semua);
      const ppn = this.formData.use_ppn ? this.formData.ppn_amount || 0 : 0;
      const pph = this.formData.use_pph ? this.formData.pph_amount || 0 : 0;
      return this.formatCurrency(dpp + ppn - pph);
    },
    ppn_amount_display() {
      return this.formatCurrency(this.formData.ppn_amount || 0);
    },
    pph_amount_display() {
      return this.formatCurrency(this.formData.pph_amount || 0);
    },
    total_koli() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        // Koli mengikuti jumlah koli yang masuk Stuffing Container (koli_in)
        if (invoice.koli_in != null && invoice.koli_in !== "") {
          total += parseInt(invoice.koli_in) || 0;
        } else {
          invoice.ttb.ttb_rinci.forEach(data => {
            total += parseInt(data.koli);
          });
        }
      });

      return total;
    },
    total_kubikasi() {
      // Kubikasi mengambil dari nilai Nota (freight charge dgn satuan M3),
      // bukan dari TTB rinci. Jika Nota tidak memakai satuan M3,
      // tampilkan kubikasi TTB sebagai referensi.
      let totalNota = 0;

      const iSatuan = (this.formData.i_satuan || "").toString().toUpperCase();
      const iiSatuan = (this.formData.ii_satuan || "").toString().toUpperCase();

      if (iSatuan === "M3") {
        totalNota += parseFloat(this.formData.i_jumlah) || 0;
      }
      if (iiSatuan === "M3") {
        totalNota += parseFloat(this.formData.ii_jumlah) || 0;
      }

      if (totalNota > 0) {
        return totalNota.toFixed(2);
      }

      // fallback referensi dari TTB
      let totalTtb = 0;
      this.invoiceDetil.forEach(invoice => {
        (invoice.ttb.ttb_rinci || []).forEach(data => {
          totalTtb += parseFloat(data.m3) || 0;
        });
      });

      return totalTtb.toFixed(2);
    },
    total_tonase() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += data.ton;
        });
      });

      return total.toFixed(2);
    },
    tgl_nota() {
      const tgl =
        (this.formData && this.formData.tgl_lunas) ||
        (this.data && this.data.tgl_lunas);
      if (!tgl) return "";
      let date = new Date(tgl);
      if (Number.isNaN(date.getTime())) return "";
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  watch: {
    total_semua(val) {
      // Recalculate PPN and PPh when total changes
      if (this.formData.use_ppn && this.formData.ppn_percentage) {
        const dpp = this.convertToAngka(val);
        this.formData.ppn_amount =
          (dpp * (this.formData.ppn_percentage || 0)) / 100;
      }
      if (this.formData.use_pph && this.formData.pph_percentage) {
        const dpp = this.convertToAngka(val);
        this.formData.pph_amount =
          (dpp * (this.formData.pph_percentage || 0)) / 100;
      }
      // Update terbilang based on grand total if using PPN/PPh, otherwise use base total
      this.updateTerbilang();
    },
    grand_total() {
      this.updateTerbilang();
    },
    "formData.terbilang"(val) {
      if (!this.formData) {
        this.updateInvoice();
      }
    },
    "formData.ppn_percentage"(val) {
      if (this.formData.use_ppn) {
        const dpp = this.convertToAngka(this.total_semua);
        this.formData.ppn_amount = (dpp * (val || 0)) / 100;
        this.updateInvoice();
      }
    },
    "formData.pph_percentage"(val) {
      if (this.formData.use_pph) {
        const dpp = this.convertToAngka(this.total_semua);
        this.formData.pph_amount = (dpp * (val || 0)) / 100;
        this.updateInvoice();
      }
    }
  },
  methods: {
    async fetchTaxPercentages() {
      try {
        const response = await axios.get("variables");
        const variables = response.data;
        const ppnVar = variables.find(v => v.key === "ppn");
        const pphVar = variables.find(v => v.key === "pph23");
        if (ppnVar && ppnVar.value !== undefined && ppnVar.value !== null) {
          this.defaultPpnPercentage = parseFloat(ppnVar.value);
        }
        if (pphVar && pphVar.value !== undefined && pphVar.value !== null) {
          this.defaultPphPercentage = parseFloat(pphVar.value);
        }
      } catch (err) {
        console.error("Error fetching tax percentages:", err);
      }
    },
    onPpnChange() {
      if (this.formData.use_ppn) {
        this.formData.ppn_percentage = this.defaultPpnPercentage;
        const dpp = this.convertToAngka(this.total_semua);
        this.formData.ppn_amount = (dpp * this.formData.ppn_percentage) / 100;
      } else {
        this.formData.ppn_amount = 0;
        this.formData.ppn_percentage = 0;
      }
      this.updateInvoice();
    },
    onPphChange() {
      if (this.formData.use_pph) {
        this.formData.pph_percentage = this.defaultPphPercentage;
        const dpp = this.convertToAngka(this.total_semua);
        this.formData.pph_amount = (dpp * this.formData.pph_percentage) / 100;
      } else {
        this.formData.pph_amount = 0;
        this.formData.pph_percentage = 0;
      }
      this.updateInvoice();
    },
    updateTerbilang() {
      if (this.formData.use_ppn || this.formData.use_pph) {
        this.formData.terbilang = this.pembilang(
          this.convertToAngka(this.grand_total)
        );
      } else {
        this.formData.terbilang = this.pembilang(
          this.convertToAngka(this.total_semua)
        );
      }
    },
    async printInvoice() {
      this.state.loadingPrint = true;

      await axios
        .get(`invoice/nota-by-nomor?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          if (!res.data.nomor_nota) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loadingPrint = false;

          setTimeout(() => {
            window.print();
          }, 500);
        })
        .catch(err => {
          this.state.loadingPrint = false;

          alert(err.response.data.message);
        });
    },
    setInvoiceData(val) {
      this.haveNomorNota = true;

      // Initialize tax fields if they don't exist
      this.formData = {
        ...val,
        use_ppn: val.use_ppn || false,
        ppn_percentage: val.ppn_percentage || 0,
        ppn_amount: val.ppn_amount || 0,
        use_pph: val.use_pph || false,
        pph_percentage: val.pph_percentage || 0,
        pph_amount: val.pph_amount || 0
      };
      this.fetchInvoiceDetil();
      this.fetchVesselInfo();
    },
    fetchInvoice() {
      this.loading.nomor_nota = true;

      axios
        .post(`invoice/fetch-invoice`, this.findForm)
        .then(res => {
          this.formData = res.data.invoice;
          this.fetchInvoiceDetil();
          this.fetchVesselInfo();

          this.loading.nomor_nota = false;
        })
        .catch(err => {
          this.loading.nomor_nota = false;

          alert(err.response.data.message);
        });
    },
    fetchInvoiceDetil() {
      this.loading.invoiceDetil = true;

      axios
        .get(`invoice/invoice-detil?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          this.invoiceDetil = res.data;

          this.loading.invoiceDetil = false;
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    fetchVesselInfo() {
      if (!this.formData.kv) {
        this.vesselInfo = null;
        return;
      }

      axios
        .get(`vessel/${this.formData.kv}`)
        .then(res => {
          this.vesselInfo = res.data || null;
        })
        .catch(() => {
          this.vesselInfo = null;
        });
    },
    fetchCustomers() {
      this.loading.customers = true;

      axios
        .get(`invoice/customers`)
        .then(res => {
          this.items.customers = res.data.map(item => ({
            text: `${item.nama} - ${item.kota} - ${item.alamat}`,
            value:
              item.status == "penerima"
                ? "PENERIMA-" + item.id
                : "PENGIRIM-" + item.id
          }));

          this.loading.customers = false;
        })
        .catch(err => {
          this.loading.customers = false;

          alert(err.response.data.message);
        });
    },
    updateInvoice() {
      // Ensure tax fields exist in formData
      const dataToSend = {
        ...this.formData,
        use_ppn: this.formData.use_ppn || false,
        ppn_percentage: this.formData.ppn_percentage || 0,
        ppn_amount: this.formData.ppn_amount || 0,
        use_pph: this.formData.use_pph || false,
        pph_percentage: this.formData.pph_percentage || 0,
        pph_amount: this.formData.pph_amount || 0
      };

      axios
        .put(`invoice/update/${this.formData.nomor_nota}`, dataToSend)
        .then(res => {
          console.log("Invoice updated:", res.data);
        })
        .catch(err => {
          console.error("Update error:", err);
          alert(err.response.data.message);
        });
    },
    addInvoiceDetil() {
      this.loading.invoiceDetil = true;

      let formData = {
        kv: this.formData.nomor_nota,
        nomor_nota: this.formData.nomor_nota,
        kodettb: this.invoiceDetilFormData.kodettb
      };

      axios
        .post(`invoice/add-item`, formData)
        .then(res => {
          this.invoiceDetilFormData.kodettb = "";

          this.loading.invoiceDetil = false;

          // this.focusInputTTB();
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    deleteItem(id) {
      axios
        .delete(
          `invoice/delete?kodettb=${id}&nomor_nota=${this.formData.nomor_nota}`
        )
        .then(res => {
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    formatForm() {
      this.state = {
        loading: false,
        no_vessel: true,
        loadingPrint: false,
        noData: true
      };

      this.findForm = {
        nomor_nota: "",
        nama_kapal: ""
      };

      this.invoiceDetil = [];

      this.haveNomorNota = false;

      this.formData = {};
    },
    getKoli(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseInt(invoice.koli);
      });

      return total;
    },
    getKubikasi(data) {
      let total = 0;

      data.forEach(val => {
        total += val.m3;
      });

      return total.toFixed(2);
    },
    getTonase(data) {
      let total = 0;

      data.forEach(val => {
        total += val.ton;
      });

      return total.toFixed(2);
    },
    focusInputTTB() {
      this.$nextTick(() => {
        this.$refs.focusNoTTB.$refs.input.click();
      });
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    pembilang(nilai) {
      const _isNominalValid = nilai => {
        const regex = new RegExp(/^\d+$/);
        return !regex.test(nilai);
      };
      const _nominalWording = nilai => {
        const UNIQUE_TWELVE = 12;
        const UNIQUE_TWENTY = 20;
        const UNIQUE_TWO_HUNDRED = 200;
        const UNIQUE_TWO_THOUSAND = 2000;
        const UNIQUE_NAMING = [
          "",
          "Satu ",
          "Dua ",
          "Tiga ",
          "Empat ",
          "Lima ",
          "Enam ",
          "Tujuh ",
          "Delapan ",
          "Sembilan ",
          "Sepuluh ",
          "Sebelas "
        ];
        const TEN = 10;
        const ONE_HUNDRED = 100;
        const ONE_THOUSAND = 1000;
        const ONE_MILLION = 1000000;
        const ONE_BILLION = 1000000000;
        const ONE_TRILLION = 1000000000000;
        if (nilai < ONE_HUNDRED) {
          if (nilai < UNIQUE_TWELVE) return UNIQUE_NAMING[nilai];
          if (nilai < UNIQUE_TWENTY)
            return _nominalWording(nilai % TEN) + "Belas ";
          return (
            _nominalWording(Math.floor(nilai / TEN)) +
            "Puluh " +
            _nominalWording(nilai % TEN)
          );
        }
        if (nilai < ONE_THOUSAND) {
          if (nilai < UNIQUE_TWO_HUNDRED)
            return "Seratus " + _nominalWording(nilai % ONE_HUNDRED);
          return (
            _nominalWording(Math.floor(nilai / ONE_HUNDRED)) +
            "Ratus " +
            _nominalWording(nilai % ONE_HUNDRED)
          );
        }
        if (nilai < ONE_MILLION) {
          if (nilai < UNIQUE_TWO_THOUSAND)
            return "Seribu " + _nominalWording(nilai % ONE_THOUSAND);
          return (
            _nominalWording(Math.floor(nilai / ONE_THOUSAND)) +
            "Ribu " +
            _nominalWording(nilai % ONE_THOUSAND)
          );
        }
        if (nilai < ONE_BILLION)
          return (
            _nominalWording(Math.floor(nilai / ONE_MILLION)) +
            "Juta " +
            _nominalWording(nilai % ONE_MILLION)
          );
        return (
          _nominalWording(Math.floor(nilai / ONE_BILLION)) +
          "Miliar " +
          _nominalWording(nilai % ONE_BILLION)
        );
      };
      if (_isNominalValid(nilai)) return "Nol Rupiah";

      return _nominalWording(nilai) + "Rupiah";
    }
  },
  created() {
    this.fetchCustomers();
    this.fetchTaxPercentages();
  }
};
</script>

<style scoped>
.invoice-item {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.overflow-auto {
  overflow: auto !important;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

#section-print.report {
  padding: 2px;
}

.header {
  display: flex;
}

.header .left {
  border: 1px solid black;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}

#section-print {
  display: none;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }

  .hide-on-print {
    display: none !important;
  }
}
</style>
